import React from "react";
import { Column } from "react-table";
import { WageColumnCell } from "./WageColumnCell";
import { ActionColumnCell } from "./ActionColumnCell";
import { ReasonColumnCell } from "./ReasonColumnCell";
import { TimesheetsShiftInfo } from "../../types/Shift.types";
import { UserCellWrapper } from "./UserColumnCell/styledComponents";
import { TimesheetTabs, TimesheetSupportUserTypes, TableCollapseFormat } from "../../types/Payroll.types";
import { UserColumnCell } from "./UserColumnCell/UserColumnCell";
import { ClockInOutCell } from "./TimeColumnCell/ClockInOutCell";
import { BreakCell } from "./TimeColumnCell/BreakCell";
import { buildShiftKey } from "../../shiftUtils";
import { useAppSelector } from "../../../../redux";
import { getUserType } from "../../../../redux/selectors/auth";

type TimesheetsTableRowDataType = {
  rowData: TimesheetsShiftInfo;
  activeTabIndex: TimesheetTabs;
  rowHoverState: boolean;
  openModal?: () => void;
};

export const TableColumns: Column<TimesheetsShiftInfo|TableCollapseFormat>[] = [
  {
    id: "userColumn",
    className: "user-column",
    Cell: ({ rowData }: TimesheetsTableRowDataType) => (
      <UserCellWrapper>
        <UserColumnCell
          firstName={rowData.user.firstName}
          lastName={rowData.user.lastName}
          jobInfo={rowData.job}
          profilePic={rowData.user.profilePic}
          shiftMessageInfo={rowData.shiftMessageInfo}
          externalId={rowData.user.externalId}
        />
      </UserCellWrapper>
    ),
  },
  {
    id: "clockInOutColumn",
    className: "clock-in-out-column",
    Cell: ({ rowData, activeTabIndex, openModal }: TimesheetsTableRowDataType) => {
      if (
        ![TimesheetTabs.PENDING_REVIEW, TimesheetTabs.APPROVED, TimesheetTabs.DISPUTED].includes(
          activeTabIndex,
        )
      ) {
        return null;
      }
      const userType = useAppSelector(getUserType);
      const isSupportUser = TimesheetSupportUserTypes.includes(userType);
      const shiftKey = buildShiftKey(rowData);
      const shiftKeyString = `${shiftKey.cmId}-${shiftKey.jobId}-${shiftKey.shiftIndex}`;
      return (
        <ClockInOutCell
          shiftInfo={rowData}
          openModal={openModal!}
          showMessaging={isSupportUser}
          shiftKey={shiftKeyString}
          activeTabIndex={activeTabIndex}
        />
      );
    },
  },
  {
    id: "breakColumn",
    className: "break-column",
    Cell: ({ rowData, activeTabIndex, openModal }: TimesheetsTableRowDataType) => {
      if (
        ![TimesheetTabs.PENDING_REVIEW, TimesheetTabs.APPROVED, TimesheetTabs.DISPUTED].includes(
          activeTabIndex,
        )
      ) {
        return null;
      }
      const userType = useAppSelector(getUserType);
      const isSupportUser = TimesheetSupportUserTypes.includes(userType);
      const shiftKey = buildShiftKey(rowData);
      const shiftKeyString = `${shiftKey.cmId}-${shiftKey.jobId}-${shiftKey.shiftIndex}`;
      return (
        <BreakCell
          shiftInfo={rowData}
          openModal={openModal!}
          showMessaging={isSupportUser}
          shiftKey={shiftKeyString}
        />
      );
    },
  },
  {
    id: "reasonColumn",
    className: "reason-column",
    Cell: ({ rowData, activeTabIndex }: TimesheetsTableRowDataType) => (
      <>
        {[TimesheetTabs.DISPUTED, TimesheetTabs.REMOVED].includes(activeTabIndex) &&
          rowData.userShift.statusReason !== undefined && (
          <ReasonColumnCell rowData={rowData} activeTabIndex={activeTabIndex} />
        )}
      </>
    ),
  },
  {
    id: "totalHoursColumn",
    className: "total-hours-column",
    Cell: ({ rowData }: TimesheetsTableRowDataType) => (
      <>
        <WageColumnCell rowData={rowData} />
      </>
    ),
  },
  {
    id: "actionsColumn",
    className: "actions-column",
    Cell: ({ rowData, activeTabIndex }: TimesheetsTableRowDataType) => (
      <ActionColumnCell rowData={rowData} activeIndex={activeTabIndex} />
    ),
  },
];
